import { graphql } from "@/gql";

export const closeIncidentMutation = graphql(`
  mutation CloseIncident(
    $id: ID!
    $outcome: IncidentClosedOutcome!
    $rejection_reason: String
  ) {
    closeIncident(
      id: $id
      outcome: $outcome
      rejection_reason: $rejection_reason
    ) {
      id
      status
    }
  }
`);
